export const CONTROLEMENSAGEM_SUCESSO = 'CONTROLEMENSAGEM_SUCESSO';
export const CONTROLEMENSAGEM_INFORMACAO = 'CONTROLEMENSAGEM_INFORMACAO';
export const CONTROLEMENSAGEM_AVISO = 'CONTROLEMENSAGEM_AVISO';
export const CONTROLEMENSAGEM_ERRO = 'CONTROLEMENSAGEM_ERRO';
export const CONTROLEMENSAGEM_CLOSE = 'CONTROLEMENSAGEM_CLOSE';
